
  export default {
    meta: {
      breadcrumbs: [['i18n/home', '/', 'mobile'], 'i18n/help'],
      disableJumbotron: true,
      disableNav: true
    },
    middleware: ['breadcrumbs', 'jumbotron', 'meta-tags'],
    data () {
      return {
        basePath: 'help',
        guides: {
          energy: { title: 'Energy', icon: 'circle-bolt', url: '/guides/gas-electricity/how-to-get-cheaper-energy-bills-on-bonkers-ie/' },
          broadband: { title: 'Broadband', icon: 'wifi', url: '/guides/broadband-phone-tv/quickstart-guide-how-to-get-the-best-value-broadband-tv-and-phone-deals-on-bonkers-ie/' },
          car: { title: 'Car insurance', icon: 'car', url: '/guides/insurance/start-your-car-insurance-journey-with-bonkers-ie/' },
          mortgages: { title: 'Mortgages', icon: 'key', url: '/guides/mortgage/quickstart-guide-how-to-find-the-best-value-mortgage-on-bonkers-ie/' },
          mortprot: { title: 'Mortgage protection', icon: 'house', url: '/guides/insurance/quickstart-guide-how-to-get-the-best-value-mortgage-protection/' },
          homeins: { title: 'Home insurance', icon: 'shield-check', url: '/guides/insurance/quickstart-guide-find-the-best-value-home-insurance-with-bonkers-ie/' },
          life: { title: 'Life insurance', icon: 'users-medical', url: '/guides/insurance/quickstart-guide-how-to-get-the-best-value-life-insurance-on-bonkers-ie/' }
        }
      };
    }
  };
